import { Component, OnInit } from "@angular/core";
import { RouterLink } from "@angular/router";
import { TranslocoPipe } from "@jsverse/transloco";

@Component({
    selector: "app-not-found",
    imports: [RouterLink, TranslocoPipe],
    templateUrl: "./not-found.component.html",
    styleUrls: ["./not-found.component.css"]
})
export class NotFoundComponent implements OnInit {
    language: string;

    ngOnInit(): void {}
}

export class NotFoundModule {}
